import Control from "../../../assets/vfx/controls/control";
import { IControlStyles, useControlStyles } from "../../../assets/layouts";
import React from "react";
import Form from "../../../assets/vfx/form/form";
import { Col } from "react-bootstrap";
import { SearchContainer } from "../../../assets/vfx/search/searchContainer";
import { SearchDto, SearchFilter, SearchOperator } from "../../../assets/utils/lib/searchDto";
import { SectionService } from "./sectionService";
import { Constants } from "../../../assets/utils/lib/constants";
import { defaultSearchQuery, GRID_ACTION_TYPES, sortBy } from "../../../assets/types";
import { ControlDataGridColumnProps } from "../../../assets/vfx/controls/components/datagrid/controlDataGrid";
import { SectionDto } from "../../../services/dto";
import {
  createActionColumn,
  createLayoutOptions,
} from "../../../assets/configuration/gridConfig";
import { QuestionnaireType } from "../questionnaireForm/questionnaireContainer";

interface QuestionnaireSectionPageProps {
  questionnaireId?: string | undefined;
  questionnaireType?: string | undefined;
  controlStyles?: IControlStyles | undefined;
  onCustomEvent?: (actionType: string, dataId: string) => void;
}

const DATA_ID_FIELD = "id";

const gridColumns: ControlDataGridColumnProps[] = [
  {
    data: DATA_ID_FIELD,
    title: "ID",
    visible: false,
    columnType: "number",
    alignment: "right",
    sortable: false,
  },
  {
    data: "name",
    title: "Name",
    visible: true,
    columnType: "text",
    alignment: "left",
    sortable: false,
    width: "25%",
  },
  {
    data: "description",
    title: "Description",
    visible: true,
    columnType: "text",
    alignment: "left",
    width: "25%",
  },
  {
    data: "startDate",
    title: "Start Date",
    visible: true,
    columnType: "date",
    alignment: "left",
    width: "20%",
  },
  {
    data: "endDate",
    title: "End Date",
    visible: true,
    columnType: "date",
    alignment: "left",
    width: "20%",
  },
];

interface SectionSearch {
  name: string;
}

const sectionInitialValues: SectionSearch = {
  name: Constants.emptyString,
};

export const SectionPage = (props: QuestionnaireSectionPageProps) => {
  const updatedSearchQuery: SearchDto = {
    ...defaultSearchQuery,
    filters: [
      ...defaultSearchQuery.filters,
      {
        field: "questionnaireId",
        operator: SearchOperator.Equal,
        value: props.questionnaireId,
      },
    ],
  };

  const [searchQuery, setSearchQuery] =
    React.useState<SearchDto>(updatedSearchQuery);

  const styles: IControlStyles = props.controlStyles ?? useControlStyles();
  const sectionGridQuery = SectionService.gridQuery(searchQuery);
  const { data } = sectionGridQuery;
  const isGridLoading = sectionGridQuery.isLoading || sectionGridQuery.isFetching;
  const sections: SectionDto[] = data?.result ?? [];
  const hasData: boolean = sections.length > 0;
  const actionColumn = createActionColumn(styles, DATA_ID_FIELD, [
    GRID_ACTION_TYPES.EDIT,
    GRID_ACTION_TYPES.VIEW,
  ]);
  const layoutOptions = createLayoutOptions(hasData);

  const handleSearch = (values: SectionSearch): void => {
    const filters: SearchFilter[] = [...updatedSearchQuery.filters];    

    if (values.name) {
      filters.push({
        field: "name",
        operator: SearchOperator.Contains,
        value: values.name,
      });
    }

   setSearchQuery({
      filters,
      pageSize: 10,
      pageNumber: 1,
      sorts: [sortBy],
    });    
  };

  const handleClear = (): void => {
    setSearchQuery((prev) => ({
      ...updatedSearchQuery,
      sorts: prev.sorts,
      pageSize: prev.pageSize ?? 10,
    }));
  };
  const handleNew = (): void | undefined =>
    props.onCustomEvent?.(GRID_ACTION_TYPES.NEW, Constants.emptyGuid);

  return (
    <>
      {props.questionnaireType != QuestionnaireType.Poll.toLowerCase() && (
        <SearchContainer
          initialValues={sectionInitialValues}
          onSearch={handleSearch}
          onNew={handleNew}
          onClear={handleClear}
          enableReinitialize
        >
          <Col lg={4}>
            <Form.Text name={"name"} label={"Name"} />
          </Col>
        </SearchContainer>
      )}

      <Control.DataGrid
        dataId={DATA_ID_FIELD}
        cols={gridColumns}
        actionCol={actionColumn}
        layoutOptions={layoutOptions}
        onCustomEvent={props.onCustomEvent}
        data={sections}
        totalRecords={data?.totalSize ?? sections?.length ?? 0}
        query={searchQuery}
        loading={isGridLoading}
        onQueryChange={(patch) => setSearchQuery(query => ({ ...query, ...patch, sorts: patch.sortBy ? [patch.sortBy] : query.sorts }))}
      />
    </>
  );
};
